<div>
	<!-- FastLink. The only state that mounts the Yodlee iframe, so the frame's own
	     error page can never be the last thing the client is left looking at. -->
	<div *ngIf="view === 'linking'">
		<div class="modal-header">
			<div class="row w-100">
				<div class="col-md-11">
					<h5 class="modal-title float-start">Link External Account</h5>
				</div>
				<div class="col-md-1 pe-0">
					<button type="button" class="close float-end text-white pe-0" aria-label="Close"
						data-testid="modals.link-account.close-btn"
						(click)="closeModal()">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</div>
		</div>
		<span *ngIf="showYodleeLoader"><img src="./assets/images/loading-buffering.gif" width="30" class="loader-yodlee" alt="Loading" /></span>
		<form #yodleeForm [action]="fastlinkUrl" method="POST" name="yodleeForm" target="abc" novalidate>
			<input type="hidden" name="app" value="10003600" />
			<input type="hidden" name="rsession" [value]="rsessionToken" class="rsession" />
			<input type="hidden" name="token" [value]="fastLinkToken" class="token" />
			<input type="hidden" name="redirectReq" value="true" />
			<input type="hidden" name="extraParams" [value]="callBackUrl" />
		</form>
		<iframe name="abc" class="bank-iframe-position" title="Link your financial institution"></iframe>
	</div>

	<!-- Confirming with the API whether anything actually got linked. -->
	<div *ngIf="view === 'verifying'">
		<div class="modal-header">
			<div class="row w-100">
				<div class="col-md-12">
					<h5 class="modal-title float-start">Finishing Up</h5>
				</div>
			</div>
		</div>
		<div class="modal-body">
			<p class="mt-3">Confirming your linked accounts...</p>
		</div>
	</div>

	<!-- Confirmed linked. -->
	<div *ngIf="view === 'success'">
		<div class="modal-header">
			<div class="row w-100">
				<div class="col-md-11">
					<h5 class="modal-title float-start">Account Linked</h5>
				</div>
				<div class="col-md-1 pe-0">
					<button type="button" class="close float-end text-white pe-0" aria-label="Close"
						data-testid="modals.link-account.success-close-btn"
						(click)="closeModal()">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</div>
		</div>
		<div class="modal-body">
			<p class="mt-3" *ngIf="linkedInstitutions.length">
				We linked <strong>{{ linkedInstitutions.join(', ') }}</strong>.
			</p>
			<p class="mt-3" *ngIf="!linkedInstitutions.length && newlyLinkedCount > 0">
				We linked your new account connection.
			</p>
			<p class="mt-3" *ngIf="!linkedInstitutions.length && newlyLinkedCount === 0">
				Your account connection was updated successfully.
			</p>
			<p>
				We are importing your balances and holdings now. This can take a few minutes, and your
				net worth will update as the information arrives.
			</p>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary btn-sm rounded-pill" (click)="closeModal()"
				data-testid="modals.link-account.success-done-btn">
				Done
			</button>
		</div>
	</div>

	<!-- Client backed out inside FastLink. Rails saved nothing in this branch. -->
	<div *ngIf="view === 'cancelled'">
		<div class="modal-header">
			<div class="row w-100">
				<div class="col-md-11">
					<h5 class="modal-title float-start">Linking Cancelled</h5>
				</div>
				<div class="col-md-1 pe-0">
					<button type="button" class="close float-end text-white pe-0" aria-label="Close"
						data-testid="modals.link-account.cancelled-close-btn"
						(click)="closeModal()">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</div>
		</div>
		<div class="modal-body">
			<p class="mt-3">
				The linking window was closed before it finished, so no accounts were added. Nothing on
				your account has changed.
			</p>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary btn-sm rounded-pill me-2" (click)="retryLinking()"
				data-testid="modals.link-account.retry-btn">
				Try Again
			</button>
			<button type="button" class="btn btn-link" (click)="closeModal()"
				data-testid="modals.link-account.cancelled-close-footer-btn">
				CLOSE
			</button>
		</div>
	</div>

	<!-- Flow ended but nothing could be confirmed as linked. -->
	<div *ngIf="view === 'failed'">
		<div class="modal-header">
			<div class="row w-100">
				<div class="col-md-11">
					<h5 class="modal-title float-start">No Accounts Were Linked</h5>
				</div>
				<div class="col-md-1 pe-0">
					<button type="button" class="close float-end text-white pe-0" aria-label="Close"
						data-testid="modals.link-account.failed-close-btn"
						(click)="closeModal()">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</div>
		</div>
		<div class="modal-body">
			<p class="mt-3">
				The linking window closed, but we could not confirm any newly linked accounts.
			</p>
			<p *ngIf="verifyUnavailable">
				We also could not reach the server to double-check. If you did complete the linking
				steps, refresh your dashboard in a few minutes before trying again.
			</p>
			<p *ngIf="!verifyUnavailable">
				If you did not finish signing in at your institution, nothing was changed. You can try
				again, or contact your advisor if this keeps happening.
			</p>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary btn-sm rounded-pill me-2" (click)="retryLinking()"
				data-testid="modals.link-account.failed-retry-btn">
				Try Again
			</button>
			<button type="button" class="btn btn-link" (click)="closeModal()"
				data-testid="modals.link-account.failed-close-footer-btn">
				CLOSE
			</button>
		</div>
	</div>

	<!-- Could not get a FastLink token at all — the third-party linking software is down. -->
	<div *ngIf="view === 'apiError'">
		<div class="modal-header">
			<div class="row w-100">
				<div class="col-md-11">
					<h5 class="modal-title">Error Linking External Account</h5>
				</div>
				<div class="col-md-1 pe-0">
					<button type="button" class="close float-end text-white pe-0" aria-label="Close"
						data-testid="modals.link-account.error-close-btn"
						(click)="closeModal('error')">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</div>
		</div>
		<div class="modal-body">
			<div>
				<p class="mt-3">The third-party linking software encountered technical difficulties. Please try again later.</p>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary btn-sm rounded-pill" (click)="closeModal('error')"
				data-testid="modals.link-account.error-close-confirm-btn">
				Close
			</button>
		</div>
	</div>
</div>
